<template>
  <!-- 班级帖子选择关联内容 -->
  <div class="about-content">
    <div class="details-top">
      <form action="/" class="logo-container">
        <van-search v-model="searchContent" right-icon="" shape="round" placeholder="搜索内容"
                    @search="onCourseSearchEnter"
                    :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
            <van-icon name="search"/>
          </template>
        </van-search>
      </form>
      <div class="sec-flex">
        <div :class="['flex-txt', active === item.code ? 'cur' : '']" v-for="item in tabList" :key="item.code"
             @click="handleItems(item.code)">
          <span>{{ item.name }}</span>
          <img v-show="item.code === active" src="@/assets/images/grade/img2.png" class="icon1" alt=""/>
        </div>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="con-list">
      <div class="con-item" v-for="(item, index) in searchList" :key="index" @click="handleClickItems(index)">
        <img src="@/assets/images/grade/select.png" v-if="item.isCheck" class="icon-item" alt="">
        <img src="@/assets/images/teacher-task/un-select.png" v-else class="icon-item" alt="">
        <div class="item-con">
          <img :src="item.coverUrl" class="con-cover" alt="">
          <div class="con-txt">{{ item.title }}</div>
        </div>
      </div>
    </van-list>
    <div class="confirm-btn" @click="handleConfirm">确定</div>
  </div>
</template>
<script>
import {homeSearch} from '@/api/api'
import {debounce} from '../../utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
import {handleTraceSearchLog} from '../../utils/trace'

const UserProfile = {
  data() {
    return {
      tabList: [{code: '1', name: '文献'}, {code: '3', name: '病例'}, {code: '2', name: '课程'}],
      active: '1',
      searchContent: '',
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      type: '1',
      load: false,
      searchList: [],
      dccId: '',
      from: ''
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    this.dccId = this.$route.query.dccId
    const type = this.$route.query.type
    this.from = this.$route.query.from
    this.active = type || '1'
    this.type = type || '1'
    this.examineType = this.$route.query.examineType
    if (this.examineType === 'course') {
      this.tabList = [{code: '2', name: '课程'}]
    }
  },
  methods: {
    onCourseSearchEnter(e) {
      this.eachStorage()
      if (e) {
        this.searchContent = e
      }
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.searchContent,
        'sessionId': localStorage.getItem('sessionId'),
        'type': this.from === 'gradeIep' ? 12 : this.from === 'gradeMock' ? 13 : '',
        'entrance': 55,
      })
      this.onLoad()
      return false
    },
    onLoad() {
      if (this.load) {
        return
      }
      this.load = true
      homeSearch({
        'userId': this.userInfo.id,
        'searchContent': this.searchContent,
        'sessionId': localStorage.getItem('sessionId'),
        'type': this.type, // '类型0全部1文献2课程3病例',
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      }).then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        let changeAboutCon = []
        if (JSON.parse(localStorage.getItem('changeAboutCon'))) {
          let aboutObj = {
            1: 'docc',
            2: 'course',
            3: 'case'
          }
          changeAboutCon = JSON.parse(localStorage.getItem('changeAboutCon'))[aboutObj[this.type]]
        }
        res.data.list.map(item => {
          item.isCheck = false
          if (changeAboutCon && changeAboutCon.length > 0) {
            changeAboutCon.map(changeItem => {
              if (item.baseId === changeItem.baseId) {
                item.isCheck = true
              }
            })
          }
        })
        this.searchList = this.searchList.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.searchList.length <= 0) {
          this.isSearch = true
        } else {
          this.isSearch = false
        }
        this.pageNum++
      })
    },

    handleItems: debounce(function (type) {
      this.eachStorage()
      this.type = type
      this.active = type
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      this.onLoad()
    }, 400),

    eachStorage() {
      let storageCon = {}

      // 从localStorage中获取已有的选中项
      if (localStorage.getItem('changeAboutCon')) {
        storageCon = JSON.parse(localStorage.getItem('changeAboutCon'))
      } else {
        storageCon = {
          docc: [],
          course: [],
          case: [],
        }
      }

      // 根据当前类型获取对应的选中项列表
      const typeKey = {'1': 'docc', '2': 'course', '3': 'case'}[this.type]
      const currentSelected = this.searchList.filter(res => res.isCheck)

      // 获取已有的选中项列表
      const existingSelected = storageCon[typeKey] || []

      // 创建一个Map来存储已有的选中项，以id为键
      const existingMap = new Map(existingSelected.map(item => [item.baseId, item]))

      // 合并当前选中项到已有的选中项中，避免重复
      currentSelected.forEach(item => {
        if (!existingMap.has(item.baseId)) {
          existingMap.set(item.baseId, item)
        }
      })

      // 遍历缓存中的每一项，检查是否在当前显示的列表中且未被勾选
      existingSelected.forEach(item => {
        const currentItem = this.searchList.find(res => res.baseId === item.baseId)
        if (currentItem && !currentItem.isCheck) {
          existingMap.delete(item.baseId)
        }
      })

      // 更新storageCon
      storageCon[typeKey] = Array.from(existingMap.values())

      // 保存到localStorage
      localStorage.setItem('changeAboutCon', JSON.stringify(storageCon))
    },
    clearSearchValue(e) {
      this.onCourseSearchEnter()
    },

    handleClickItems(index) {
      this.searchList[index].isCheck = !this.searchList[index].isCheck
    },
    handleConfirm() {
      this.eachStorage()
      this.$router.go(-1)
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.about-content {
  min-height: 100vh;
  width: 100%;
  background: #F9F8F7;
  padding-top: 100px;
  box-sizing: border-box;

  .details-top {
    width: 100%;
    height: 90px;
    background-color: #F9F8F7;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .logo-container {
      /deep/ .van-search {
        background-color: transparent;

        .van-search__content {
          border: 1px solid #F1EFED;
          background: rgba(255, 255, 255, 0.5);

          .van-field__control {
            color: #949BA5;
            font-weight: 400;
            font-size: 13px;
            &::placeholder {
              color: #949BA5;
              font-weight: 400;
              font-size: 13px;
            }
          }
        }
      }
    }

    .sec-flex {
      display: flex;
      // padding: 0 45px;
      box-sizing: border-box;
      height: 42px;
      align-items: center;
      background-color: #F9F8F7;
      justify-content: space-between;

      .flex-txt {
        position: relative;
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        color: #656E7F;
        font-weight: 500;
        flex: 1;
        text-align: center;

        &:nth-last-child(1) {
          margin-right: 0;
        }

        &.cur {
          font-weight: 600;
          color: #EB1700;
        }

        .icon1 {
          position: absolute;
          width: 23px;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .con-list {
    padding: 10px 16px;
    box-sizing: border-box;

    .con-item {
      background-color: #fff;
      padding: 10px 8px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border-radius: 12px;
      margin-bottom: 10px;

      .icon-item {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }

      .item-con {
        display: flex;
        align-items: center;

        .con-cover {
          width: 110px;
          height: 60px;
          object-fit: cover;
          margin-right: 6px;
          min-width: 110px;
          border-radius: 8px;
        }

        .con-txt {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .confirm-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    font-weight: 500;
    color: #fff;
    background-color: #EB1700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/aboutContent.vue